<div class="image-crop-dialog">
  <div class="image-crop-dialog__header p-3 flex align-items-center justify-content-between border-bottom-1 border-300">
    <h2 class="mb-0 text-sm">{{ header | translate }}</h2>
    <button
      type="button"
      class="border-none bg-transparent p-0 cursor-pointer"
      (click)="ref.close()"
      aria-label="close-image-crop-dialog"
      data-testid="close-image-crop-dialog">
      <i class="fa fa-times text-xl text-500"></i>
    </button>
  </div>

  <div class="image-crop-dialog__body p-3 md:flex">
    <div class="w-12 md:w-8">
      @if (imageFile) {
        <image-cropper
          class="image-crop-dialog__cropper"
          [imageFile]="imageFile"
          [imageQuality]="100"
          [maintainAspectRatio]="true"
          [containWithinAspectRatio]="containWithinAspectRatio"
          [aspectRatio]="aspectRatio"
          [resizeToWidth]="256"
          [cropperMinWidth]="128"
          [onlyScaleDown]="true"
          [roundCropper]="roundCropper"
          [canvasRotation]="canvasRotation"
          [transform]="transform"
          [alignImage]="'left'"
          [style.display]="showCropper ? null : 'none'"
          format="png"
          (imageCropped)="imageCropped($event)"
          (imageLoaded)="imageLoaded()"
          (cropperReady)="cropperReady($event)"
          (loadImageFailed)="loadImageFailed()" />
      }
    </div>

    <div class="md:w-4">
      <h5 class="text-sm my-3 md:mt-0">{{ 'common.IMAGE_CROP.PREVIEW' | translate }}</h5>
      <img
        [src]="croppedImage"
        class="image-crop-dialog__preview"
        [style.border]="croppedImage ? '1px solid var(--gray-300)' : 'none'"
        alt="image-crop-preview" />
    </div>
  </div>

  <div class="image-crop-dialog__footer px-3 py-3 border-top-1 border-300 flex align-items-center justify-content-between">
    <p-button
      (click)="ref.close()"
      [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
      styleClass="p-button-link text-sm"
      aria-label="cancel-image-crop-button"
      data-testid="cancel-image-crop-button" />
    <p-button
      styleClass="text-sm"
      (click)="doneCropping()"
      [label]="'common.BUTTONS.BUTTON-TEXT-SAVE' | translate"
      aria-label="save-image-crop-button"
      data-testid="save-image-crop-button" />
  </div>
</div>
